<div class="vg-bg-deco" aria-hidden="true">
  <div class="blob-primary"></div>
  <div class="blob-secondary"></div>
  <div class="dot-grid"></div>
</div>

<div style="position: relative; z-index: 1;">
  <router-outlet />
</div>
